import sendMessageToSidebar from '@/taskpane/events/messages/send-message-to-sidebar'
import { defaultMessageArgs } from '@/taskpane/events/messages/message-args'
import storage from '@/taskpane/common/local-storage'
import state from '@/taskpane/state/sidebar-state'
import configuration from '@/taskpane/common/configuration'
import { showLoginPopup } from '../generated/fallbackauthdialog'
import { logErrorToApi } from '@/taskpane/common/error-logging'

export function shouldShowLoginPopup() {
  if (state.testingGraphAccess) {
    state.testingGraphAccess = false
    state.resetGraphAccessAlertFlag()
    showLoginPopup()
  } else if (storage.getLocalItem(configuration.IGNORE_GRAPH_LOGIN_FLAG) === 'true') {
    if (state.shouldSendGraphAccessAlert()) {
      const args = {
        ...defaultMessageArgs(),
        connected: false,
      }

      sendMessageToSidebar('GraphAccessAlert', args)
    }
  } else if (state.shouldSendGraphLoginRequest()) {
    setTimeout(() => {
      sendMessageToSidebar('GraphLoginRequest', defaultMessageArgs())
    }, 3000)
  }
}

export function handleGraphLoginError(text: string): void {
  const args = {
    ...defaultMessageArgs(),
    connected: false,
    message: text,
  }
  logErrorToApi('Graph API Error', 'Exception occurred during Graph API request', null, null, {
    context: 'graph-api-login-helper',
    operation: 'handleGraphLoginError',
    message: text,
  })
  if (state.shouldSendGraphAccessAlert()) {
    sendMessageToSidebar('GraphAccessAlert', args)
  }
}
